import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './store';
import App from './App';

const container = document.getElementById('root') as HTMLElement;

if (!container) {
  throw new Error(
    'Failed to find the root element. Please ensure an element with id "root" exists in your HTML.'
  );
}

const root = ReactDOM.createRoot(container);

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

reportWebVitals();
